<template>
  <el-dialog title="选择方案" :visible.sync="dialogVisible" width="30%" append-to-body :close-on-click-modal="false">
      <el-input size="small" suffix-icon="el-icon-search" placeholder="请输入搜索关键字" v-model="filterKeyWord" clearable spellcheck="false" />
      <div class="schem-list">
        <div v-for="schem in filterSchems" :key="schem.id" class="schem-item" :class="{'item_selected':selectSchem && selectSchem.id===schem.id}" @click="handleSelectSchem(schem)" >
            <span >
              <i :class="selectSchem && selectSchem.id===schem.id?'el-icon-folder-checked':'el-icon-folder'" style="margin-right:5px" />
              {{ schem.programName }} 
            </span>
            <div v-if="alter"><i class="el-icon-close sd-hover"  @click="handleDeleteSchem(schem.id)" v-hasPermi="['gis:schem:delete']" ></i></div>
        </div>
      </div>
      <div v-if="selectSchem" class="select-schem-info">
        当前方案：
        <el-input :disabled="!$auth.hasPermi('gis:schem:update')" size="mini" v-model="selectSchem.programName" style="width:calc(100% - 75px)"></el-input>
      </div>
      <div v-else style="height:40px;"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="saveSchemName" v-hasPermi="['gis:schem:update']" v-if="alter">保存</el-button>
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleConfirmSchem">
              确定
          </el-button>
        </span>
      </template>
    </el-dialog>
</template>

<script>
import {  getAllTree, delsche, saveTree,putsche } from "@/api/layer.js"
import PinyinMatch from "pinyin-match"
export default {
  name: 'SchemDialog',
  props: {
    selectFirst:{
        type:Boolean,
        default:true
    },
    alter:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      selectSchem:null,
      filterKeyWord:'',
      dialogVisible:false,
      schems:[],
      filterSchems:[],
    };
  },
  mounted() {
    
  },
  watch:{
    filterKeyWord(){
      this.filterList(this.filterKeyWord)
    }
  },
  methods: {
    handleSelectSchem(schem){
      if (this.selectSchem) {
        this.selectSchem = schem.id===this.selectSchem.id?null:schem
      }else{
        this.selectSchem = schem
      }
    },
    getList(){
      return new Promise((resolve,reject)=>{
        getAllTree().then((res) => {
          if (res.data.code == 200) {
            this.schems = res.data.data
            this.filterList()
            resolve()
          }
        }).catch(()=>{
          reject()
        })
      })
      
    },
    filterList(keyword){
      if (keyword) {
        this.filterSchems = this.schems.filter(item=>{
          return PinyinMatch.match(item.programName,keyword)
        })
      }else{
        this.filterSchems = this.schems
      }
      
    },
    handleConfirmSchem(){
        this.close()
        this.$emit('confirm',this.selectSchem?.programName)
    },
    handleDeleteSchem(id){
      this.$confirm('是否删除此方案？','警告', {confirmButtonText: '是',cancelButtonText: '否', type: 'warning',})
        .then(() => {
            delsche(id).then((res) => {
                if (res.data.code == 200) {
                    this.getList()
                    this.$message({
                        message: '删除成功！',
                        type: 'success',
                    })
                } else {
                  this.$message({
                        message: '删除失败！',
                        type: 'error',
                    })
                }
            })
        })
    },
    saveSchemName(){
      if (this.selectSchem) {
        const {id,programName} = this.selectSchem
        putsche({programName,id}).then((res) => {
          if (res.data.code == 200) {
            this.$message({type: 'success', message: `修改方案名称成功！`,})
          } else {
            this.$message({type: 'error',message: '修改方案名称失败！',})
          }
        })
      }
    },
    saveSchem(data,isNotSaveAs=true){
      if (isNotSaveAs && this.selectSchem) {
        //修改
        this.$confirm(`是否保存修改方案【${this.selectSchem.programName}】？`,'提示', {confirmButtonText: '是',cancelButtonText: '否', type: 'info',})
        .then(()=>{
          const {checkedKeys,forest,halfCheckedKeys} = data
          const {id} = this.selectSchem
          putsche({checkedKeys,forest,halfCheckedKeys,id}).then((res) => {
            if (res.data.code == 200) {
              this.$message({type: 'success', message: `保存方案成功！`,})
            } else {
              this.$message({type: 'error',message: '保存方案失败！',})
            }
          })
        })
        return
      }
      //新增方案
      this.$prompt('请输入方案名称', '保存方案', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(({ value }) => {
        if(this.checkNotSameName(value)){
          data.programName=value,
          saveTree(data).then((res) => {
            if (res.data.code == 200) {
              this.$message({type: 'success', message: `新增方案成功！`,})
            } else {
              this.$message({type: 'error',message: '保存失败！',})
            }
          })        
        }
        
      })
      .catch(() => {
      })
    },
    checkNotSameName(schemName){
      this.schems.forEach(item=>{
        if (item.programName===schemName) {
          this.$message({type: 'error',message: '方案名称已存在！',})
          return false
        }
      })
      return true
    },
    open(schemName){
        this.getList().then(()=>{
          if (schemName) {
            this.selectSchemByName(schemName)
          }
        })
        this.dialogVisible = true
    },
    close(){
        this.dialogVisible = false
    },
    selectSchemByName(schemName){
      if (this.selectSchem && this.selectSchem.programName === schemName) return
      let schem
      this.schems.some(item=>{
        if (schemName===item.programName) {
          schem = item
          return true
        }
      })
      if (schem) {
        this.selectSchem = schem
      }
    }
  },
};
</script>

<style scoped>
.schem-list{
  height: 300px;
  margin-top: 10px;
  overflow-y: auto;
}
.schem-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  margin: 5px;
  border-radius: 2px;
  border: 1px solid #eee;
  font-size: 15px;
  position:relative;
  cursor:pointer;
}
.schem-item:hover{
  background-color: #eee;
  color: black;
}
.item_selected{
  border: 1px solid #409eff ;
}
.item_selected::after{
  content: '\2713';
  display: block;
  font-size: 10px;
  line-height: 10px;
  text-align: right;
  color: white;
  background: linear-gradient(45deg, transparent , transparent  50%, #409eff 50%, #409eff 100%);
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0px;
  top: 0px;
}
.schem-item-name{
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schem-item-delete{
  cursor: pointer;
}
.schem-item-delete:hover{
  color: #409eff;
}
.schem-item-name{
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schem-item-delete{
  cursor: pointer;
}
.schem-item-delete:hover{
  color: #409eff;
}
.select-schem-info{
  /* float: left; */
  width: 100%;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
</style>
